import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {EventBusChunkAwareErrorHandler} from "../handlers/event-bus-chunk-aware-error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class ErrorMessageInterceptor implements HttpInterceptor {
  private translate = inject(TranslateService);
  private errorService = inject(EventBusChunkAwareErrorHandler);

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(body => {
        this.errorService.error$.next(body);
        if (body.error && body.error.code) {
          body.errorMessage = body.error.code === 'E1014'
            ? 'E1014: ' + (body.error.message || body.error.errorMessage)
            : body.errorMessage = this.translate.instant('ERROR_MESSAGES.' + body.error.code);
        } else {
          body.errorMessage = body.status
            ? this.translate.instant('ERROR_MESSAGES.' + body.status)
            : this.translate.instant('ERROR_MESSAGES.500');
        }

        if (body.errorMessage.includes('ERROR_MESSAGES')) {
          body.errorMessage = this.translate.instant('ERROR_MESSAGES.500');
        }

        return observableThrowError(body);
      }));
  }
}
